import React, { Component } from 'react';
import Loader from 'react-loader-spinner'
import './Carousel.css';

export default class Slide extends Component {

    componentDidMount = () => {
        // if(this.props.isActive){
        //     setTimeout(this.sendGrowMessage,1000);
        // }
    }

    componentDidUpdate = () => {
        if (this.props.isActive) {
            this.sendGrowMessage();
        }
        else {
            this.sendShrinkMessage();
        }
    }

    sendGrowMessage = () => {
        if (!this.container) return;
        this.container.contentWindow.postMessage({
            type: 'grow',
        }, '*');
    }

    sendShrinkMessage = () => {
        if (!this.container) return;
        this.container.contentWindow.postMessage({
            type: 'shrink',
        }, '*');
    }

    iframeLoaded = () => {
        setTimeout(this.removeLoadingWatches, 1500);
    }

    removeLoadingWatches() {
        var elements = document.getElementsByClassName("loadingWatch");
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.opacity = 0;
        }
        setTimeout(() => {
            while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
            }
        }, 1000);
    }

    render() {
        var { data } = this.props;
        return (
            <div className="slide">
                <iframe id={data.name + this.props.index} style={{ border: "none" }} title={data.display} height="512px" width="512px" src={`/watches/${data.name}`}
                    ref={e => { this.container = e }} onLoad={this.iframeLoaded} />
                <div className="loadingWatch">
                    <Loader type="Watch" color="#fff" height={80} width={80} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Carousel/Slide.js